// third party plugins
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Badge } from "reactstrap";

// presentational components
import FilterHeaderText from "components/Filters/FilterHeaderText.jsx";
import FilterRow from "components/Filters/List/FilterRow.jsx";

// utils
import { filterValuesList } from "./utils.js";

export const FilterHeader = React.memo(({ filterDisplayName }) => (
  <div className="card border-0">
    <div className="card-header border-0 bg-white pl-3 pt-1 pb-1">
      <FilterHeaderText
        className="d-inline-block text-uppercase"
        text={filterDisplayName}
      />
    </div>
  </div>
));

FilterHeader.displayName = "FilterHeader";

FilterHeader.propTypes = {
  filterDisplayName: PropTypes.string.isRequired,
};

export const FilterContent = React.memo(
  ({
    filterName,
    filterValue,
    filterSequence,
    appliedDynamicFilters,
    onToggle,
    onFilterCategoryReset,
    checkboxClassName = "",
  }) => {
    const appliedFiltersCount = appliedDynamicFilters?.get(filterName)?.size;
    const filterValues = filterValuesList(
      filterName,
      filterValue,
      filterSequence,
      appliedDynamicFilters,
      onToggle
    );

    return (
      <div className="filter-item">
        {appliedFiltersCount > 0 && (
          <StyledBadge
            className="mb-1"
            pill
            onClick={onFilterCategoryReset}
            data-category={filterName}
          >
            Clear
          </StyledBadge>
        )}

        {filterValues?.map((props) => (
          <FilterRow
            key={`${filterName}-${props?.id || props?.value}`}
            checkboxClassName={checkboxClassName}
            {...props}
          />
        ))}
      </div>
    );
  }
);

FilterContent.displayName = "FilterContent";

FilterContent.propTypes = {
  filterName: PropTypes.string.isRequired,
  filterValue: PropTypes.object.isRequired,
  filterSequence: PropTypes.object.isRequired,
  appliedDynamicFilters: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  onFilterCategoryReset: PropTypes.func.isRequired,
};

const StyledBadge = styled(Badge)`
  background-color: #e7f1f8;
  color: #3b90dd;
  margin-top: 10px;
  margin-left: 19px;
  font-size: 0.7rem;
  padding: 0.3rem;
  font-weight: 500;
  cursor: pointer;
`;
